import { styled } from "goober";

export const AuthorizedButton = styled("div")`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 6px 6px 20px;
  border-radius: 9999px;
  background: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  width: max-content;
`;

export const AuthorizedLabel = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const AuthorizedInfo = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 8px;
`;

export const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
      fill="#6EDC78"
      stroke="#6EDC78"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 6L5.5 7.5L8.5 4.5"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
